import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { uid } from '@fiverr-private/futile/lib/random/uid';
import { isSinglePackage } from '../../../reducers/packages';

export const GIG_ITEM_PREFIX = 'gig_items';
export const GIG_ITEM_ID = 'gig_item_id';
export const QUANTITY = 'quantity';

class FormGigItem extends Component {

    formatInputName(type, gigItemUid) {
        const { isSinglePackage, packageId } = this.props;

        if (isSinglePackage) {
            return `${GIG_ITEM_PREFIX}[${gigItemUid}][${type}]`;
        } else {
            return `${GIG_ITEM_PREFIX}[${packageId}][${gigItemUid}][${type}]`;
        }
    }

    getFormGigItemInputNames() {
        const gigItemUid = uid();

        return {
            gigItemIdName: this.formatInputName(GIG_ITEM_ID, gigItemUid),
            quantityName: this.formatInputName(QUANTITY, gigItemUid)
        };
    }

    render() {
        const { id, quantity } = this.props;
        const { gigItemIdName, quantityName } = this.getFormGigItemInputNames();

        return (
            <div>
                <input type="hidden" name={gigItemIdName} value={id}/>
                <input type="hidden" name={quantityName} value={quantity}/>
            </div>
        );
    }
}

FormGigItem.propTypes = {
    packageId: PropTypes.number,
    id: PropTypes.number,
    quantity: PropTypes.number,
    isSinglePackage: PropTypes.bool
};

const mapStateToProps = ({ packages }) => ({
    isSinglePackage: isSinglePackage(packages)
});

export { FormGigItem };

export default connect(mapStateToProps)(FormGigItem);
